import { render } from "./VideoPlayerControlsSettingsSplitView.vue?vue&type=template&id=04da2080"
import script from "./VideoPlayerControlsSettingsSplitView.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsSettingsSplitView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__